import {KTCard} from '../../../../../../../../_metronic/helpers'
import {ListViewProvider, useListView} from './core/ListViewProvider'
import {QueryRequestProvider} from './core/QueryRequestProvider'
import {QueryResponseProvider} from './core/QueryResponseProvider'
import {PropertiesTable} from './table/PropertiesTable'

const PropertiesList = () => {
  const {itemIdForUpdate} = useListView()
  return (
    <>
      <div className='mt-n8 py-3'>
        <KTCard>
          <PropertiesTable />
        </KTCard>
      </div>
      {itemIdForUpdate !== undefined}
    </>
  )
}

const PropertiesListWrapper = () => (
  <QueryRequestProvider>
    <QueryResponseProvider>
      <ListViewProvider>
        <PropertiesList />
      </ListViewProvider>
    </QueryResponseProvider>
  </QueryRequestProvider>
)

export {PropertiesListWrapper}
